import { cn } from "@/lib/cn";

interface InputProps extends React.ComponentProps<"input"> {
  ref?: React.Ref<HTMLInputElement>;
}

const Input = ({ className, type, ref, ...props }: InputProps) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-sm border border-border bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = "Input";

/**
 * A field on the front door (sign-in, password and consent screens): as tall as its `xl` button, with
 * skillpanel.com's flush 1px focus ring. Admin fields keep the base ring with its offset
 */
const FRONT_DOOR_INPUT =
  "h-12 rounded-xl text-base transition-colors duration-200 focus-visible:border-ring focus-visible:ring-1 focus-visible:ring-offset-0";

export { FRONT_DOOR_INPUT, Input };
